var map = {
	"./bicycool2.jpg": 2923,
	"./harakiri.jpg": 9600,
	"./home_section_howitworks00.png": 4112,
	"./magnetik.jpg": 9123,
	"./markem.jpg": 6196,
	"./mikros.jpg": 4702,
	"./nestor.jpg": 3528,
	"./shooting.jpg": 4310
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45;